import { fromEvent as observableFromEvent, Observable } from 'rxjs';

import {debounceTime, distinctUntilChanged, share, window} from 'rxjs/operators';
import { Injectable } from '@angular/core';

function getWindow(): any {
    return window;
}

function getObject(): any {
    return Object;
}

@Injectable()
export class GlobalObjectsRefService {
    get nativeWindow(): any {
        return getWindow();
    }

    get nativeObject(): any {
        return getObject();
    }

    getNativeWindow(): any {
        return getWindow();
    }

    /**
     * Creates a new observable that can be used in place of a window:resize event listener.
     * @param {number} throttle
     * Debounce timer, allow actions only after specific time has passed.
     * @returns {Observable<any>}
     */
    getWindowResizeObs(throttle = 100) {
        return observableFromEvent(getWindow(), 'resize').pipe(debounceTime(throttle), distinctUntilChanged());
    }
}
